
import { Order } from '../../types';

export const parseBasicOrderText = (text: string): Order => {
    const lines = text.split('\n').filter(l => l.trim());
    if (/retirada|balcão|takeaway/i.test(text)) throw new Error('PICKUP_DETECTED');

    let id = Math.floor(Math.random() * 9000 + 1000).toString();
    let platformId = undefined;
    let customerName = 'Cliente Desconhecido';
    let orderValue = 0;
    let deliveryFee = 0;
    let createdAt = Date.now();

    // Tenta identificar o ID curto (displayId)
    const idLine = lines.find(l => /Pedido\s*N[ºo]/i.test(l));
    if (idLine) {
        const match = idLine.match(/Pedido\s*N[ºo]\s*(\d+)/i);
        if (match) id = match[1];
    }

    // Tenta identificar um ID longo de plataforma (8+ dígitos)
    const longIdMatch = text.match(/\b(\d{8,12})\b/);
    if (longIdMatch) {
        platformId = longIdMatch[1];
    }

    const totalLine = lines.find(l => /VALOR FINAL:|TOTAL:|TOTAL DO PEDIDO:/i.test(l));
    if (totalLine) {
        const valStr = totalLine.split(':').pop()?.replace(/[^0-9,.]/g, '').replace(',', '.') || '0';
        orderValue = parseFloat(valStr);
    }

    return { 
        id, 
        platformId,
        customerName, 
        address: 'Ver texto original', 
        streetAddress: 'Pendente',
        neighborhood: 'Pendente',
        items: 'Itens diversos', 
        orderValue, 
        deliveryFee, 
        paymentMethod: 'Dinheiro', 
        timeLimit: 45,
        createdAt, 
        salesChannel: 'Site Próprio', 
        type: 'DELIVERY',
        status: 'pending', 
        costThirdParty: 0, 
        isReady: false 
    };
};

export const parseMultipleOrdersText = (text: string): Order[] => {
    const splitPattern = /(?=#️⃣\s*Pedido)/i;
    const rawChunks = text.split(splitPattern).filter(c => c.trim().length > 20);
    const orders: Order[] = [];
    for (const chunk of rawChunks) {
        try { const order = parseBasicOrderText(chunk); if (order) orders.push(order); } catch (e) {}
    }
    return orders;
};
